<div class="px-2 sm:px-4 md:px-6 py-4 max-w-6xl mx-auto">
  <!-- Header -->
  <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-6">
    <h1 class="text-2xl font-bold text-gray-800 flex items-center">
      <mat-icon style="color: #1C593D; margin-right: 8px;">wifi</mat-icon>
      Usuarios Conectados
      <span class="relative flex h-3 w-3 ml-2" *ngIf="socketConnected">
        <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
        <span class="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
      </span>
      <span class="relative flex h-3 w-3 ml-2" *ngIf="!socketConnected">
        <span class="relative inline-flex rounded-full h-3 w-3 bg-gray-400"></span>
      </span>
      <!-- Badge desktop -->
      <span class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
        {{ uniqueUsers }} usuarios &middot; {{ totalConnections }} conexiones
      </span>
    </h1>
  </div>
  <!-- Badge mobile -->
  <span class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mb-4">
    {{ uniqueUsers }} usuarios &middot; {{ totalConnections }} conexiones
  </span>

  <!-- Stage badge -->
  <div class="mb-4" *ngIf="stage">
    <span class="text-xs font-semibold px-2 py-1 rounded-full"
      style="background: #ecfdf5; color: #1C593D;">
      Ambiente: {{ stage }}
    </span>
  </div>

  <!-- Stat cards -->
  <div class="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
    <button type="button" class="stat-card" (click)="setFilter('all')"
      [class.stat-card--active]="activeFilter === 'all'">
      <span class="stat-card__value">{{ uniqueUsers }}</span>
      <span class="stat-card__label">Total</span>
    </button>
    <button type="button" class="stat-card stat-card--ve" (click)="setFilter('VE')"
      [class.stat-card--active]="activeFilter === 'VE'">
      <span class="stat-card__value">{{ clientsVE }}</span>
      <span class="stat-card__label">Venezuela</span>
    </button>
    <button type="button" class="stat-card stat-card--cl" (click)="setFilter('CL')"
      [class.stat-card--active]="activeFilter === 'CL'">
      <span class="stat-card__value">{{ clientsCL }}</span>
      <span class="stat-card__label">Chile</span>
    </button>
    <button type="button" class="stat-card stat-card--op" (click)="setFilter('operators')"
      [class.stat-card--active]="activeFilter === 'operators'">
      <span class="stat-card__value">{{ operators }}</span>
      <span class="stat-card__label">Operadores</span>
    </button>
  </div>

  <!-- Filter indicator -->
  <div class="mb-4 flex items-center gap-2">
    <span class="text-sm text-gray-500">Mostrando:</span>
    <span class="text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full">
      {{ filteredUsers.length }} usuarios
    </span>
  </div>

  <!-- User cards -->
  <div class="space-y-3">
    <div *ngIf="filteredUsers.length === 0" class="text-center text-sm text-gray-400 py-8">
      No hay usuarios conectados
    </div>
    <div *ngFor="let user of filteredUsers; let i = index"
      class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
      [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'">

      <!-- Card header -->
      <div class="card-header flex items-center justify-between p-3 cursor-pointer"
        (click)="toggleCard(i)"
        [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'">
        <div class="flex items-center gap-2 flex-1 min-w-0">
          <span class="relative flex h-2 w-2 shrink-0">
            <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
            <span class="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
          </span>
          <span class="font-mono font-bold text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full shrink-0">{{ user.userId }}</span>
          <span class="px-2 py-0.5 text-xs font-bold rounded-full shrink-0"
            [style.background]="getUserTypeBadge(user).color + '18'"
            [style.color]="getUserTypeBadge(user).color">
            {{ getUserTypeBadge(user).label }}
          </span>
          <span class="text-xs font-semibold text-gray-800 truncate">{{ user.nombre }} {{ user.apellidos }}</span>
        </div>
        <mat-icon class="text-gray-400 shrink-0 transition-transform duration-200"
          [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>

      <!-- Card body -->
      <div *ngIf="expandedCardId === i" class="card-details px-3 pb-3 border-t border-gray-100">
        <div class="grid grid-cols-2 gap-2 mt-3 text-xs">
          <div class="col-span-2">
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Email</span>
            <p class="font-medium mt-0.5" style="color: #2563eb;">{{ user.email }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Tabs abiertos</span>
            <p class="font-semibold mt-0.5" style="color: #374151;">{{ user.tabs }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Conectado hace</span>
            <p class="font-medium mt-0.5" style="color: #374151;">{{ getTimeAgo(getEarliestConnection(user)) }}</p>
          </div>
        </div>

        <!-- Conexiones -->
        <div class="mt-3 pt-3 border-t border-gray-100" *ngIf="user.connections?.length">
          <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Conexiones</span>
          <div class="space-y-2 mt-2">
            <div *ngFor="let conn of user.connections"
              class="flex items-center gap-2 text-xs"
              style="background: #f9fafb; padding: 6px 8px; border-radius: 8px;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #6b7280;">{{ getDeviceIcon(conn.deviceType) }}</mat-icon>
              <span style="color: #374151;">{{ conn.browser }} &middot; {{ conn.os }}</span>
              <span style="color: #9ca3af;">{{ conn.country }}</span>
              <span style="color: #9ca3af; margin-left: auto;">{{ getTimeAgo(conn.connectedAt) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
